var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from "@material-ui/core";
import React from "react";
export const FTLTableRow = React.forwardRef((_a, ref) => {
    var { type = "default", height, isDisabled, isFocusable, className = "" } = _a, otherProps = __rest(_a, ["type", "height", "isDisabled", "isFocusable", "className"]);
    const { root } = useStyles({
        type,
        height,
        isDisabled,
        isFocusable,
    });
    return React.createElement("tr", Object.assign({ ref: ref, className: className + " " + root }, otherProps));
});
const useStyles = makeStyles((theme) => ({
    root: ({ type = "default", isDisabled, isFocusable, height = "auto", }) => {
        let styles = {
            height,
            pointerEvents: isDisabled ? "none" : "auto",
            "&:last-child td": {
                boxShadow: "none",
            },
            boxSizing: "border-box",
        };
        if (isFocusable)
            styles = Object.assign(Object.assign({}, styles), { "&:hover": {
                    backgroundColor: "#f5f9ff",
                }, "&:focus": {
                    outline: `2px ${theme.palette.border.focus}`,
                } });
        if (type === "head")
            styles = Object.assign(Object.assign({}, styles), { boxShadow: "none" });
        return styles;
    },
}));
//# sourceMappingURL=FTLTableRow.js.map